<template>
  <div class="card">
    <div class="card-body p-0 py-4">
        <div class="d-flex justify-content-between align-items-center px-4 pb-3">
          <div class="d-flex">
            <h2 class="m-0">Details</h2>
          </div>
          <div style="position: relative;">  
            <div class="button-text d-flex justify-content-center align-items-center mt-2">
              <a @click="openDexTool()" class="btn-theme">Dextools</a>
              <a @click="openContract()" class="btn-theme">Contract</a>
              <a @click="openOwner()" class="btn-theme">Owner</a>
              <a @click="openTS()" class="btn-theme">TS</a>
              <div class="button-text d-flex justify-content-center align-items-center" 
              >
                <a 
                  :style="hpResult && hpResult.honeypotResult && hpResult.honeypotResult.isHoneypot == true ? 'background-color: black;' : ''"
                  @click="openHPInfo()" class="btn-theme"
                >HoneyPotIs</a>
              </div>
              <a @click="goBack()" class="btn-theme">👈 Go Back</a>
            </div>
          </div>
        </div>
        <div class="table-responsive" style="overflow-x: hidden!important;">
          <table class="table m-0 align-items-center border0 w-100"  style="margin-top: 25px!important;">
              <tbody>
                <tr>
                  <th style="">Name:</th>
                  <td  style=" text-align:left;    font-size: 19px;    color: black;">{{contract.get('name')}}</td>
                  <th style="">Symbol: </th>
                  <td  style=" text-align:left;    font-size: 19px;    color: black;">{{contract.get('symbol')}}</td>
                  <th style="">Time:</th>
                  <td  style=" text-align:left;    font-size: 19px;    color: black;">{{formatTime(contract.get('createdAt'))}} <b>({{timeSince(contract.get('createdAt'))}} ago) </b></td>
                </tr>
                <tr>
                  <th>PairETH:</th>
                  <td  style=" text-align:left;    font-size: 19px;    color: black;">{{pairBalance}}</td>
                  <th>PnL:</th>
                  <td  style=" text-align:left;    font-size: 19px;    color: black;">
                    <span style="font-weight: 900; font-size: 18px;" :class="tokenProfit < 0 ? 'text-danger' : 'text-success'">{{tokenProfit}}</span>
                  </td>
                  <th>OwnerETH:</th>
                  <td  style=" text-align:left;    font-size: 19px;    color: black;">
                    {{ ownerBalance }}
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
    </div>

    <div class="card-body p-0 py-0 pb-1 w-full">
      <div class="d-flex justify-content-between align-items-center px-4 pb-3">
        <h2 class="m-0">HoneyPot info</h2>
        <img @click="showHPInfo=false;" v-if="showHPInfo" style="width: 30px; height: 30px; cursor: pointer;" class="action-icon" src="img/unobserve.svg"/>
        <img @click="showHPInfo=true;" v-else style="width: 30px; height: 30px;cursor: pointer;" class="action-icon" src="img/observe.svg"/>
      </div>
      <div class="w-full px-4" v-if="showHPInfo && hpResult">
        <div class="d-flex w-full justify-content-between">
          <div class="w-50">
            <b>Simulation</b>
            <VueJsonPretty :path="'res'" :data="hpResult.simulationResult" style="max-width: 100%; overflow-x: auto;"/>
          </div>
          <div class="w-50">
            <div>
              <b>Result</b>
              <VueJsonPretty :path="'res'" :data="hpResult.honeypotResult" style="max-width: 100%; overflow-x: hidden;"/>
            </div>
            <div>
              <b>Flags</b>
              <div v-if="hpResult.flags">
                {{ hpResult.flags.join(', ') }}
              </div>
              <!-- <VueJsonPretty :path="'res'" :data="hpResult.flags" style="max-width: 100%; overflow-x: hidden;"/> -->
            </div>
            <div>
              <b>Holder Analysis</b>
              <VueJsonPretty :path="'res'" :data="hpResult.holderAnalysis" style="max-width: 100%; overflow-x: hidden;"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Web3 from '@/helpers/Web3';
import Utils from '@/helpers/Utils';
import VueJsonPretty from 'vue-json-pretty'
import Parse from "@/helpers/Parse";

export default {
  name: "Details",
  props: ['contract', 'watch'],
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      bbAddr: [],
      tokenValueAmount: 0,
      tokenPnl: '_',
      buybackETH: '_',
      pairBalance: '_',
      hpResult: {},
      showHPInfo: false,

      timer: null,
      ownerBalance: 0,
    };
  },
  computed: {
    ...mapGetters({
      config: 'transactions/config'
    }),
    tokenProfit() {
      return this.formatBalance(parseInt(this.tokenPnl));
    },
  },
  watch: {
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  async mounted() {
    this.refreshAll();
    this.timer = setInterval(this.refreshAll, 5000);
  },
  methods: {
    ...mapActions({
      createUpdateWatch: 'watches/createUpdate'
    }),
    formatTime(date) {
      const formatter = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const formattedTime = formatter.format(date);

      const formattedDate = (new Intl.DateTimeFormat('en-US', { dateStyle: 'short' })).format(date);

      return formattedTime + ' ' + formattedDate;
    },
    timeSince(date) {
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return Math.floor(interval) + " years";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " months";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " days";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " hours";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    },
    updatePnL() {
      const address = this.contract.get('address');
      const updater = async () => {
        const orderQuery = Parse.getQuery('Order');
        orderQuery.matches('token1', address, 'i');
        orderQuery.limit(500);
        const orders = await orderQuery.find();
        // eslint-disable-next-line no-undef
        let totalPnl = BigInt(0);
        orders.map(order => {
          if (order.get('type') == 'buy') {
            // eslint-disable-next-line no-undef
            totalPnl -= BigInt(order.get('ethAmount')) + BigInt(order.get('gasFee'))
          } else {
            // eslint-disable-next-line no-undef
            totalPnl += BigInt(order.get('ethAmount')) - BigInt(order.get('gasFee'))
          }
        })
        this.tokenPnl = totalPnl;
      };
      updater();
    },
    manualRefresh() {
      clearInterval(this.timer);
      this.refreshAll();
      this.timer = setInterval(this.refreshAll, 5000);
    },
    async updateBB() {
      const aggregator = Web3.getAggregatorContract();
      this.tokenValueAmount = await aggregator.methods.getTokenValue().call();
    },
    async refreshAll() {
      this.refreshPairWETH();
      this.updatePnL();
      this.updateBB();
      const owner = this.contract.get('owner');
      if (owner) {
        this.ownerBalance = this.formatBalance(await Web3.getBalance(owner));
      }
      
      // if (Web3.getNetwork().network == 'base') {
      //   return;
      // }
      
      const hpUrl = `https://api.honeypot.is/v2/IsHoneypot?address=${
        this.contract.get('address')
      }`;
      fetch(hpUrl).then(res => res.json())
      .then(result => {
        this.hpResult = result;
      });
    },
    goBack() {
      this.$router.push({name: 'Home'});
    },
    async setBBAddr() {
      const text = await navigator.clipboard.readText();
      const addresses = text.match(/(\b0x[a-fA-F0-9]{40}\b)/g)
      this.bbAddr = addresses;
    },
    formatBalance(balance, decimals, delimiter) {
      if (!balance) {
        return '_';
      }
      return Utils.formatBalance(balance, decimals, delimiter);
    },
    getNetwork() {
      return this.contract.get('network');
    },
    formatTotalSupply() {
      let decimals = this.contract.get('decimals') || 18;
      let totalSupply = this.contract.get('totalSupply') || 18;
      // eslint-disable-next-line no-undef
      return (BigInt(totalSupply) / BigInt(10 ** decimals)).toString();
    },
    openDexTool() {
      const explorers = {
        'main': 'https://www.dextools.io/app/ether/pair-explorer',
        'base': 'https://www.dextools.io/base/ether/pair-explorer',
      }
      window.open(`${explorers[this.contract.get('network')]}/${this.contract.get('address')}`);
    },
    openContract() {
      const explorers = {
        'main': 'https://etherscan.io/address',
        'base': 'https://basescan.org/address',
      }
      window.open(`${explorers[this.contract.get('network')]}/${this.contract.get('address')}`);
    },
    openOwner() {
      const explorers = {
        'main': 'https://etherscan.io/address',
        'base': 'https://basescan.org/address',
      }
      window.open(`${explorers[this.contract.get('network')]}/${this.contract.get('owner')}`);
    },
    openTS() {
      let network = this.getNetwork().network;
      if (network == 'main') {
        network = 'eth';
      }
      const url = `https://tokensniffer.com/token/${network}/${this.contract.get('address')}`;
      window.open(url);
    },
    openHPInfo() {
      let network = this.getNetwork().network;
      if (network == 'main') {
        network = 'ethereum';
      }
      const url = `https://honeypot.is/${network}?address=${this.contract.get('address')}`;
      window.open(url);
    },
    async refreshPairWETH() {
      const dex = Web3.getDexListByNetwork(this.contract.get('network'))[this.config.factory];
      await Web3.initByNetwork(this.contract.get('network'));
      const factory = Web3.getUniswapV2FactoryContract(dex.address);
      
      const pairAddress = await factory.methods.getPair(Web3.getWETHAddressByNetwork(this.contract.get('network')), this.contract.get('address')).call();
      
      const ethBalance = await Web3.getTokenBalance(Web3.getWETHAddressByNetwork(this.contract.get('network')), pairAddress);
      
      this.pairBalance = this.formatBalance(ethBalance, null, 4);
    },
  },
};
</script>
<style scoped>
.action-icon {
  width: 30px;
  height: 30px;
}

@media only screen 
    and (max-width: 767px), (min-device-width: 767px) 
    and (max-device-width: 767px)  {

		/* Force table to not be like tables anymore */
		table, thead, tbody, th, td, tr {
			display: block;
		}

		/* Hide table headers (but not display: none;, for accessibility) */
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}

    tr {
      margin: 0 0 1rem 0;
    }
      
    /* tr:nth-child(odd) {
      background: #ccc;
    } */
    
		td {
			/* Behave  like a "row" */
			border: none;
			border-bottom: 1px solid #eee;
			position: relative;
			padding-left: 50%;
      width: 100% !important;
		}

		td:before {
			/* Now like a table header */
			position: absolute;
			/* Top/left values mimic padding */
			top: 50%;
			left: 24px;
			padding-right: 10px;
			white-space: nowrap;
      transform: translate(0px, -50%);
      color: #444444;
		}

		/*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
    tr:nth-of-type(1) td:nth-of-type(1):before { content: "Name: "; }
		tr:nth-of-type(1) td:nth-of-type(2):before { content: "Symbol: "; }
		tr:nth-of-type(1) td:nth-of-type(3):before { content: "Total Supply: "; }
		tr:nth-of-type(2) td:nth-of-type(1):before { content: "Function: "; }
    tr:nth-of-type(2) td:nth-of-type(2):before { content: "Tax Buy/Sell: "; }
		tr:nth-of-type(2) td:nth-of-type(3):before { content: "Dead Blocks: "; }
		tr:nth-of-type(3) td:nth-of-type(1):before { content: "Decimals: "; }
		tr:nth-of-type(3) td:nth-of-type(2):before { content: "Max Tx/Wallet: "; }
		tr:nth-of-type(3) td:nth-of-type(3):before { content: "Owner Balance: "; }
    th {
      display: none;
    }
	}
</style>